import React from 'react';
import { useParams } from 'react-router-dom';
import IdeaStageDetails from '../../screens/StagesScreens/IdeaStageDetails';
import ValleyStageDetails from '../../screens/StagesScreens/ValleyStageDetails';
import GrowthStageDetails from '../../screens/StagesScreens/GrowthStageDetails';
import NotFound from '../NotFoundComponents/NotFound';

const StageDetails = () => {
  const { stageId } = useParams();

  if (stageId === "idea-stage") {
    return <IdeaStageDetails />;
  } else if (stageId === "valley-stage") {
    return <ValleyStageDetails />;
  } else if (stageId === "growth-stage") {
    return <GrowthStageDetails />;
  } else {
    return <NotFound />;
  }
};

export default StageDetails;
